import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'

import { UploadButton, UploadList } from "../../components";

import { Input,InputDecimal, DatePicker,Information } from "../core";
import utilityHelper from '../../helpers/helperUtil'
import { red } from "@material-ui/core/colors";
import { getAllUserAction } from "../../redux/actions/UserAction";
import AdjustmentSelect from '../../components/AdjustmentSelect';
import IconButton from "@material-ui/core/IconButton";

class PanelFineMom extends Component {

    constructor(props) {
        super(props)

        this.state = {
            transaction_no:'',
            ir_amount:0,
            sum_penalty_cal:0,
            retention_cal:0,
            advance_payment_cal:0,
            mr_amount:0,
            openAdjustmentSelect:false,
            openReservedAdjustmentSelect:false
        }
        
        this.handleChange = this.handleChange.bind(this)
        this.handleฺฺBure = this.handleฺฺBure.bind(this)
        // this.handleChangeByName = this.handleChangeByName.bind(this)
        this.handleInTimeChange = this.handleInTimeChange.bind(this)
        this.handlePenaltyChange = this.handlePenaltyChange.bind(this)
        this.handleNoPenaltyChange = this.handleNoPenaltyChange.bind(this)
        
        this.handleOtherPenaltyChange = this.handleOtherPenaltyChange.bind(this)
        this.handleRetentionChange = this.handleRetentionChange.bind(this)
        this.handleAdvancePaymentChange = this.handleAdvancePaymentChange.bind(this)
        this.renderUpDeptDate = this.renderUpDeptDate.bind(this)
        this.renderDownDeptDate = this.renderDownDeptDate.bind(this)
        this.handleUpDeptChange = this.handleUpDeptChange.bind(this)
        this.handleDownDeptChange = this.handleDownDeptChange.bind(this)

        this.chkNumber = this.chkNumber.bind(this)
        this.recalIRAmount = this.recalIRAmount.bind(this)
        this.recalMRAmount = this.recalMRAmount.bind(this)
        this.setFormateMomey = this.setFormateMomey.bind(this)
        this.renderNotifyDocDate = this.renderNotifyDocDate.bind(this)
        this.renderApproveDocDate = this.renderApproveDocDate.bind(this)        
        this.renderReserveDocDate = this.renderReserveDocDate.bind(this)
        this.renderNoPenaltyApproveNo = this.renderNoPenaltyApproveNo.bind(this)
        this.renderNoPenaltyReserveNo = this.renderNoPenaltyReserveNo.bind(this)
        this.renderNoPenaltyNotifyNo = this.renderNoPenaltyNotifyNo.bind(this)
        this.renderPenaltyNotifyNo = this.renderPenaltyNotifyNo.bind(this)

        this.handleOnOpenAdjustmentSelect = this.handleOnOpenAdjustmentSelect.bind(this)
        this.handleOnCloseAdjustmentSelect = this.handleOnCloseAdjustmentSelect.bind(this)

        window.handleMRAmount = this.handleMRAmount.bind(this)
        
        //this.penalty_flag_ref = React.createRef();
        //this.no_penalty_flag_ref = React.createRef();
        this.other_penalty_flag_ref = React.createRef();

        this.no_penalty_approve_no_ref  = React.createRef();
        this.no_penalty_notify_no_ref  = React.createRef();
        this.no_penalty_reserved_no_ref = React.createRef();
        
        // this.penalty_result_ref = React.createRef();
        // this.penalty_no_result_ref = React.createRef();
        // this.delay_day_no_ref = React.createRef();
        this.delay_remark_ref = React.createRef();

        this.no_penalty_notify_date_ref = React.createRef();
        this.no_penalty_reserved_date_ref = React.createRef();

        // this.penalty_amount_ref = React.createRef();
        // this.penalty_doc_no_ref = React.createRef();
        // this.penalty_doc_date_ref = React.createRef();

        this.approval_of_penalty_exception_doc_no_ref = React.createRef();
        //this.approval_of_penalty_exception_doc_date_ref = React.createRef();

        //this.other_penalty_amount_ref = React.createRef();
        this.other_penalty_remark_ref = React.createRef();
        this.delay_day_no = React.createRef();
        //this.retention_amount_ref = React.createRef();
        this.retention_remark_ref = React.createRef();
        //this.advance_payment_amount_ref = React.createRef();
        this.advance_payment_remark_ref = React.createRef();
        this.down_dept_remark_ref = React.createRef();       
         this.up_dept_remark_ref = React.createRef();
    }
    handleMRAmount(){
        //this.recalIRAmount()
    }
    chkNumber(value){
        return value?parseFloat(value.toString().replace(/[^0-9.-]+/g,"")):0
    }
    setFormateMomey(value){
        const numeral = require('numeral');
        return numeral(value).format("0,0.00")
    }
    recalIRAmount(){
        let sum = 0;
        let { t_MR_DETAIL } = this.props;
        this.props.t_IR_ITEM.map((m, index)=>{
            if(m.amount && (m.checked===1 || m.checked===true || m.checked==='1')){
                sum += parseFloat(m.amount)
            }
        })
        // if(this.state.ir_amount != sum || this.props.t_MR_DETAIL.mr_ref_no!=null)
        this.setState({
            ir_amount : this.setFormateMomey(sum),
            sum_penalty_cal:
                this.setFormateMomey(
                    this.chkNumber(t_MR_DETAIL.penalty_amount)
                    +this.chkNumber(t_MR_DETAIL.other_penalty_amount)
                ),
            retention_cal:
                this.setFormateMomey(
                    this.chkNumber(t_MR_DETAIL.retention_amount)
                ),
            advance_payment_cal:
                this.setFormateMomey(
                    this.chkNumber(t_MR_DETAIL.advance_payment_amount)
                ),
            mr_amount : 
                this.setFormateMomey(
                    sum - 
                    ( 
                        this.chkNumber(t_MR_DETAIL.penalty_amount)+
                        this.chkNumber(t_MR_DETAIL.other_penalty_amount)+
                        this.chkNumber(t_MR_DETAIL.retention_amount)+
                        this.chkNumber(t_MR_DETAIL.advance_payment_amount)
                    )
                ),
        })
    }

    recalMRAmount(name,changeValue){
        let dataState = this.state
        switch(name){
            case 'penalty_amount' :
                let penalty_amount=this.props.t_MR_DETAIL.other_penalty_amount ? this.props.t_MR_DETAIL.other_penalty_amount: 0
                let calPenalty_amount =  this.chkNumber(penalty_amount)  + this.chkNumber(changeValue)
                dataState = {
                    ...dataState,
                    sum_penalty_cal : this.setFormateMomey(calPenalty_amount),
                }
            break
            case 'other_penalty_amount' :
                let other_penalty_amount =this.props.t_MR_DETAIL.penalty_amount ? this.props.t_MR_DETAIL.penalty_amount : 0 
                let calOther_penalty_amount = this.chkNumber(other_penalty_amount)  + this.chkNumber(changeValue)
                dataState = {
                    ...dataState,
                    sum_penalty_cal : this.setFormateMomey(calOther_penalty_amount),
                }
            break
            case 'retention_amount' : 
                dataState = {
                    ...dataState,
                    retention_cal : this.setFormateMomey(changeValue),
                }
            break
            case 'advance_payment_amount' : 
                dataState = {
                    ...dataState,
                    advance_payment_cal : this.setFormateMomey(changeValue),
                }
            break
        }
        dataState = {
            ...dataState,
            mr_amount : 
            this.setFormateMomey(
                this.chkNumber(dataState.ir_amount) 
                - ( 
                    this.chkNumber(dataState.sum_penalty_cal)+
                    this.chkNumber(dataState.retention_cal)+
                    this.chkNumber(dataState.advance_payment_cal)
                )
            )
        }
        this.setState(dataState)
    }
    handleฺฺBure(event){
        const numeral = require('numeral');
        
        event.target.value = numeral(this.chkNumber(event.target.value)).format('0,0.00')
    }
    handleChange(event){
        const numeral = require('numeral');
        const name = event.target.name;
        console.log(event)
        if(name === 'penalty_amount' || name === 'other_penalty_amount' || 
            name === 'retention_amount' || name === 'advance_payment_amount' || name === 'delay_day_no' || name === 'down_dept_amount'  || name === 'up_dept_amount'  ){
                event.target.value = numeral(this.chkNumber(event.target.value)).format(event.target.step);
                this.recalMRAmount(name,event.target.value)
        }
        if(name === "penalty_amount")
        {   
            const {t_MR_DETAIL} = this.props
            this.props.handleChangeByName(this.chkNumber(t_MR_DETAIL.delay_day_no) * this.chkNumber(event.target.value),"penalty_amount_net")
        }
        if(name === "delay_day_no")
        {   
            const {t_MR_DETAIL} = this.props
            this.props.handleChangeByName( this.chkNumber(event.target.value) * this.chkNumber(t_MR_DETAIL.penalty_amount),"penalty_amount_net")
        }

        this.props.handleChange(event);
    }

    handleInTimeChange(event) {
        event.target.name = "delivery_exception_flag"       
        this.props.handleChangeByName(event.target.value, 'delivery_exception_flag');
         this.handleChange(event);
        if (event.target.value === 'in_time') {
            this.clearInTimeCtr();
            this.clearPenaltyCtr();
            this.clearNoPenaltyCtr();

            
            this.props.handleChangeByName('', 'penalty_result');
            //this.penalty_result_ref.current.checked = false;
            //this.penalty_no_result_ref.current.checked = false;

            //this.no_penalty_flag_ref.current.checked = false;
            //this.penalty_flag_ref.current.checked = false;
            this.other_penalty_flag_ref.current.checked=false;

        } else {
            this.clearPenaltyCtr();
            this.clearNoPenaltyCtr();

            this.props.handleChangeByName('penalty', 'penalty_result');
            // this.penalty_result_ref.current.checked = true;
            // this.penalty_no_result_ref.current.checked = false;

            //this.no_penalty_flag_ref.current.checked = true;
            //this.penalty_flag_ref.current.checked = true;
            this.other_penalty_flag_ref.current.checked=true;

        }

    }

    handlePenaltyChange(event) {
        event.target.name = "penalty_result"
        this.handleChange(event);

        this.props.handleChangeByName(event.target.value, 'penalty_result');
        if (event.target.value === 'penalty')
        {
            this.props.handleChangeByName(true, 'penalty_flag');
            this.props.handleChangeByName(false, 'no_penalty_flag'); 
            this.props.handleChangeByName('', 'no_penalty_reserved_no');	
            this.props.handleChangeByName('', 'no_penalty_reserved_date');
            this.props.handleChangeByName('', 'no_penalty_notify_no');
            this.props.handleChangeByName('', 'no_penalty_notify_date');	
            this.props.handleChangeByName('', 'no_penalty_approve_no');	
            this.props.handleChangeByName('', 'no_penalty_approve_date');
            
        }
        else if (event.target.value === 'no_penalty'){
            this.props.handleChangeByName(false, 'penalty_flag'); 
            this.props.handleChangeByName(true, 'no_penalty_flag');        
            this.props.handleChangeByName('', 'penalty_amount');
            this.props.handleChangeByName('', 'penalty_amount_net');
            this.props.handleChangeByName('', 'penalty_doc_date');
            this.props.handleChangeByName('', 'penalty_doc_no');
        }
        else {
            this.props.handleChangeByName('', 'penalty_flag');
            this.props.handleChangeByName('', 'no_penalty_flag'); 
        } 

        //this.props.handleChangeByName('', 'other_penalty_remark');
        //this.handleNoPenaltyChange(event)
    }
    handleNoPenaltyChange(event) {
        this.handleChange(event);
        let { t_MR_DETAIL} = this.props;   

        // t_MR_DETAIL.no_penalty_approve_no  = '';
        // t_MR_DETAIL.no_penalty_notify_no   = '';
        // t_MR_DETAIL.no_penalty_reserved_no = '';       
        // this.no_penalty_approve_no_ref = '';
        this.props.handleChangeByName('', 'no_penalty_reserved_no');	
        this.props.handleChangeByName('', 'no_penalty_reserved_date');
        this.props.handleChangeByName('', 'no_penalty_notify_no');
        this.props.handleChangeByName('', 'no_penalty_notify_date');	
        this.props.handleChangeByName('', 'no_penalty_approve_no');	
        this.props.handleChangeByName('', 'no_penalty_approve_date');



    }
    handleOtherPenaltyChange(event) {
        this.handleChange(event);
        this.props.handleChangeByName('', 'other_penalty_amount');
        this.props.handleChangeByName('', 'other_penalty_remark');
        

        //this.other_penalty_amount_ref.current.value = ''
        this.other_penalty_remark_ref.current.value = ''
        this.recalMRAmount('other_penalty_amount',0)

    }

    handleRetentionChange(event){
        this.handleChange(event);
        this.props.handleChangeByName('','retention_amount');
        this.props.handleChangeByName('','retention_remark');

        //this.retention_amount_ref.current.value = ''
        this.retention_remark_ref.current.value = ''
        this.recalMRAmount('retention_amount',0)

    }

    handleAdvancePaymentChange(event){
        this.handleChange(event);
        this.props.handleChangeByName('','advance_payment_amount');
        this.props.handleChangeByName('','advance_payment_remark');
        
        //this.advance_payment_amount_ref.current.value = ''
        this.advance_payment_remark_ref.current.value = ''
        this.recalMRAmount('advance_payment_amount',0)

    }

    handleUpDeptChange(event){
        this.handleChange(event);
        this.props.handleChangeByName('','up_dept_amount');
        this.props.handleChangeByName('','up_dept_remark');
        this.props.handleChangeByName('','up_dept_date');
        
        //this.advance_payment_amount_ref.current.value = ''
//        this.up_dept_remark_ref.current.value = ''
        //this.recalMRAmount('up_dept_amount',0)

    }

    handleDownDeptChange(event){
        this.handleChange(event);
        this.props.handleChangeByName('','down_dept_amount');
        this.props.handleChangeByName('','down_dept_remark');
        this.props.handleChangeByName('','down_dept_date');
        
        //this.advance_payment_amount_ref.current.value = ''
        //this.down_dept_remark_ref.current.value = ''
        //this.recalMRAmount('down_dept_amount',0)

    }

    clearInTimeCtr() {
        this.props.handleChangeByName('', 'delay_day_no');
        this.props.handleChangeByName('', 'delay_remark');
        //this.delay_day_no_ref.current.value = ''
        this.delay_remark_ref.current.value = ''
    }

    clearPenaltyCtr() {
        this.props.handleChangeByName('', 'approval_of_penalty_exception_doc_no');
        this.props.handleChangeByName('', 'approval_of_penalty_exception_doc_date');
        //this.approval_of_penalty_exception_doc_no_ref.current.value = ''
        //this.approval_of_penalty_exception_doc_date_ref.current.value = ''
    }

    clearNoPenaltyCtr() {
        this.props.handleChangeByName('', 'penalty_amount');
        this.props.handleChangeByName('', 'penalty_doc_no');
        this.props.handleChangeByName('', 'penalty_doc_date');
        //this.penalty_amount_ref.current.value = ''
        //this.penalty_doc_no_ref.current.value = ''
        //this.penalty_doc_date_ref.current.value = ''


        this.props.handleChangeByName('', 'penalty_amount_net');
        this.props.handleChangeByName('', 'penalty_flag');				
        this.props.handleChangeByName('', 'no_penalty_flag');			
        this.props.handleChangeByName('', 'no_penalty_reserved_no');		
        this.props.handleChangeByName('', 'no_penalty_reserved_date');	
        this.props.handleChangeByName('', 'no_penalty_notify_no');		
        this.props.handleChangeByName('', 'no_penalty_notify_date');		
        this.props.handleChangeByName('', 'no_penalty_approve_no');		
        this.props.handleChangeByName('', 'no_penalty_approve_date');
        
        // this.props.handleChangeByName('', 'no_penalty_reserved_no');	
        // this.props.handleChangeByName('', 'no_penalty_reserved_date');
        // this.props.handleChangeByName('', 'no_penalty_notify_no');
        // this.props.handleChangeByName('', 'no_penalty_notify_date');	
        // this.props.handleChangeByName('', 'no_penalty_approve_no');	
        // this.props.handleChangeByName('', 'no_penalty_approve_date');

        this.props.handleChangeByName('', 'other_penalty_flag');	
        this.props.handleChangeByName('', 'other_penalty_amount');
        this.props.handleChangeByName('', 'other_penalty_remark');
        
        this.recalMRAmount('penalty_amount',0)
    }

    toBoolean(value){

            if(value === 1 )
                return true
            else if(value === true )
                return true
            else
                return false
    }
    

    componentWillReceiveProps(nextProps) {

        // console.log("PanelFine-componentWillReceiveProps()");
        if (this.state.transaction_no !== nextProps.t_MR_DETAIL.transaction_no) {
    
            if(nextProps.t_MR_DETAIL.transaction_no){
                    this.setState({
                        transaction_no: nextProps.t_MR_DETAIL.transaction_no
                    })
            }else{
                // console.log("nextProps.t_MR_DETAIL.transaction_no is null!")
            }

        }

    }

    handleOnCloseAdjustmentSelect(){
        this.setState({
            openAdjustmentSelect: false
        })
    }

    handleOnOpenAdjustmentSelect(){
        this.setState({
            openAdjustmentSelect: true
        })
    }

    handleOnSelectAdjustment(obj){

        let { t_HEADER } = this.props;

        if(t_HEADER.product_type === 'G')
        {
            this.no_penalty_notify_no_ref.current.value = obj.adjust_no;
            this.no_penalty_notify_no_ref.current.focus();
   
           this.props.handleChangeByName(obj.adjust_date, 'no_penalty_notify_date');
        }else{
            this.no_penalty_reserved_no_ref.current.value = obj.adjust_no;
            this.no_penalty_reserved_no_ref.current.focus();
           
           //this.props.handleChangeByName(obj.adjust_no, 'no_penalty_reserved_no');
           this.props.handleChangeByName(obj.adjust_date, 'no_penalty_reserved_date');    
        }
         

        this.handleOnCloseAdjustmentSelect();
    }


    handleOnCloseReservedAdjustmentSelect(){
        this.setState({
            openReservedAdjustmentSelect: false
        })
    }

    handleOnOpenReservedAdjustmentSelect(){

        console.log('handleOnOpenReservedAdjustmentSelect')
        this.setState({
            openReservedAdjustmentSelect: true
        })
    }

    handleOnSelectReservedAdjustment(obj){

         this.no_penalty_reserved_no_ref.current.value = obj.adjust_no;
         this.no_penalty_reserved_no_ref.current.focus();
        
        //this.props.handleChangeByName(obj.adjust_no, 'no_penalty_reserved_no');
        this.props.handleChangeByName(obj.adjust_date, 'no_penalty_reserved_date');        

        this.handleOnCloseReservedAdjustmentSelect();
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.t_MR_DETAIL.mr_ref_no !== this.props.t_MR_DETAIL.mr_ref_no )   
        {
            const numeral = require('numeral');
            window.$('#other_penalty_amount').val(numeral(this.props.t_MR_DETAIL.other_penalty_amount).format('0,0.00'))
            window.$('#retention_amount').val(numeral(this.props.t_MR_DETAIL.retention_amount).format('0,0.00'))
            window.$('#advance_payment_amount').val(numeral(this.props.t_MR_DETAIL.advance_payment_amount).format('0,0.00'))
            window.$('#penalty_amount').val(numeral(this.props.t_MR_DETAIL.penalty_amount).format('0,0.00'))
            window.$('#delay_day_no').val(numeral(this.props.t_MR_DETAIL.delay_day_no).format('0,0'))
            //this.recalIRAmount();
        }
    }

    
    componentDidMount() {

        $(function () {
            window.onComponentDidMount()
        })
    }

   
    renderPenaltyAmount() {
        const numeral = require('numeral');
        let { t_MR_DETAIL,viewMode } = this.props;
        //if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") {
            //|| t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined || this.toBoolean(t_MR_DETAIL.penalty_flag) == false
          if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty" || viewMode === true ){
            return <input
                name="penalty_amount"
                className="form-control form-control-190 mr-3"
                id="penalty_amount"
                value={viewMode? numeral(t_MR_DETAIL.penalty_amount).format('0,0.00') : numeral(0).format('0,0.00')}
                disabled={true}
                step = '0,0.00'
                //ref={this.penalty_amount_ref}
            />
        }
        else {
            return <InputDecimal
                name="penalty_amount"
                // pattern="[0-9.]*"
                //defaultValue={t_MR_DETAIL.penalty_result === "penalty" ? t_MR_DETAIL.penalty_amount : ''}
                className="form-control form-control-190 mr-3"
                id="penalty_amount"
                onBlur={this.handleChange}
                //onChange={this.handleChange}
                //ref={this.penalty_amount_ref}
                doctype="*"
                tagid="mr.penalty_amount"
                //value={t_MR_DETAIL.penalty_amount}
                step = '0,0.00'
                defaultValue={numeral(t_MR_DETAIL.penalty_amount).format('0,0.00')}
                inputMode="decimal"
                disabled={viewMode}
                viewMode={viewMode}
            />
        }

    }
    renderPenaltyAmountNet() {
        const numeral = require('numeral');
        let { t_MR_DETAIL,viewMode } = this.props;
        console.log("renderPenaltyAmountNet ==> ",t_MR_DETAIL)
        //if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") {
        if (t_MR_DETAIL.delivery_exception_flag === "in_time"  || t_MR_DETAIL.penalty_result !== "penalty" || viewMode=== true){
        //  || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined|| this.toBoolean(t_MR_DETAIL.penalty_flag) == false){
                return <input
                name="penalty_amount_net"
                className="form-control form-control-190 mr-3"
                value={viewMode? numeral(this.chkNumber(t_MR_DETAIL.penalty_amount_net)).format('0,0.00') : numeral(0).format('0,0.00')}
                id="penalty_amount_net"
                disabled={true}
                //ref={this.penalty_amount_ref}
            />
        }
        else {
            return <InputDecimal
                name="penalty_amount_net"
                // pattern="[0-9.]*"
                //defaultValue={t_MR_DETAIL.penalty_result === "penalty" ? t_MR_DETAIL.penalty_amount : ''}
                className="form-control form-control-190 mr-3"
                id="penalty_amount_net"
                tagid="mr.penalty_amount_net"
                value={numeral(this.chkNumber(t_MR_DETAIL.penalty_amount_net)).format('0,0.00')}
                //defaultValue={numeral(t_MR_DETAIL.penalty_amount_net).format('0,0.00')}
                inputMode="decimal"
                step="0,0.00"
                //disabled={viewMode}
                viewMode={viewMode}
                disabled={true}
            />
        }

    }

    renderPenaltyDocNo() {
        let lableName = "แจ้งสงวนสิทธิ์การปรับแล้วตามหนังสือเลขที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined|| t_MR_DETAIL.penalty_result !== "penalty") {
            return <React.Fragment>
                {/* <div className="col-auto rrs-detail-data d-flex flex-wrap">
                    <label htmlFor="penalty_doc_no" className="rrs-label mr-3">
                        {lableName} 
                    </label>
                </div> */}
                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                    <input
                        id="penalty_doc_no"
                        name="penalty_doc_no"
                        className="form-control form-control-190"
                        disabled={true}
                        maxLength="20"
                    //ref={this.penalty_doc_no_ref}
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                {/* <div className="col-auto rrs-detail-data d-flex flex-wrap">
                <label
                    id="#lbl-mr.penalty_no"
                    htmlFor="penalty_doc_no"
                    className="rrs-label mr-3" >
                    
                    {lableName}
                </label>
                </div> */}
                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                    <Input
                        name="penalty_doc_no"
                        value={t_MR_DETAIL.penalty_doc_no}
                        className="form-control form-control-190"
                        id="penalty_doc_no"
                        onChange={this.handleChange}
                        //ref={this.penalty_doc_no_ref}
                        doctype="*"
                        tagid="mr.penalty_no"
                        disabled={viewMode}
                        maxLength="20"
                        viewMode={viewMode}
                    />
                </div>
            </React.Fragment >
        }
    }

    renderPenaltyDocDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined|| t_MR_DETAIL.penalty_result !== "penalty") {
            return <React.Fragment>
                <label htmlFor="penalty_doc_date" className="rrs-label rrs-label-95">
                    {lableName} 
                </label>
                <div className="rrs-formgroup">
                    <DatePicker
                        value={t_MR_DETAIL.penalty_doc_date != null ? t_MR_DETAIL.penalty_doc_date : ''}
                        //key={`penalty_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="penalty_doc_date"
                        id="penalty_doc_date" 
                        disabled={true}
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <label 
                    id="#lbl-mr.penalty_date"
                    htmlFor="penalty_doc_date" 
                    className="rrs-label rrs-label-95" >
                    
                    {
                    (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") == false
                    && (<span className="required">*</span>)
                                    }
                    { lableName }
                </label>
                <div className="rrs-formgroup">
                    <DatePicker
                        //key={`penalty_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="penalty_doc_date"
                        id="penalty_doc_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.penalty_doc_date
                            ? moment(t_MR_DETAIL.penalty_doc_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.penalty_date"
                        disabled={viewMode}
                        viewMode={viewMode}
                    />
                </div>
            </React.Fragment>
        }
    }

    renderOtherPenaltyAmount() {
        let { t_MR_DETAIL,viewMode } = this.props;
        const numeral = require('numeral');
        if ( viewMode === true || t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined || this.toBoolean(t_MR_DETAIL.other_penalty_flag)== false) {
            return  <input
            name="other_penalty_amount"
            className="form-control form-control-190 mr-3"
            id="other_penalty_amount"
            value = {viewMode? numeral(t_MR_DETAIL.other_penalty_amount).format('0,0.00') : "0.00"}
            disabled={true}
        /> 
        }
        else {
            return <React.Fragment>
                <div className="rrs-formgroup">

                <InputDecimal
            name="other_penalty_amount"
            className="form-control form-control-190 mr-3"
            id="other_penalty_amount"
            onBlur={this.handleChange}
            //onChange={this.handleChange}
            disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined || this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false || viewMode}
            defaultValue={numeral(t_MR_DETAIL.other_penalty_amount).format('0,0.00')}
            inputMode="decimal"
            step="0,0.00"
            maxLength="6"
  
        />
                </div>
            </React.Fragment>
        }
    }
    renderNoPenaltyApproveNo() {
        let { t_MR_DETAIL,viewMode } = this.props;
       // this.toBoolean(t_MR_DETAIL.no_penalty_flag)== false 
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "no_penalty") {
            return <input
            name="no_penalty_approve_no"
            className="form-control form-control-190"

            id="no_penalty_approve_no"
            disabled={true}
            //ref={this.penalty_amount_ref}
        />
        }
        else {
            return <React.Fragment>
                <div className="rrs-formgroup">

                <input
                                    key={`no_penalty_approve_no${t_MR_DETAIL.transaction_no}`}
                                    name="no_penalty_approve_no"
                                    defaultValue={t_MR_DETAIL.no_penalty_approve_no}
                                    className="form-control form-control-190"
                                    id="no_penalty_approve_no"
                                    onBlur={this.handleChange}
                                    //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || t_MR_DETAIL.penalty_result === "penalty" || viewMode}|| t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false
                                    disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result === "penalty"   || viewMode}
                                   ref={this.no_penalty_approve_no_ref}
                                    maxLength="40"
                                   
                                />
                </div>
            </React.Fragment>
        }
    }

    renderNoPenaltyReserveNo() {
        let { t_MR_DETAIL, t_HEADER,viewMode } = this.props;
        //||  this.toBoolean(t_MR_DETAIL.no_penalty_flag)== false
        if (t_MR_DETAIL.delivery_exception_flag !== "delay_time"){// || t_MR_DETAIL.penalty_result !== "no_penalty") {
            return <input
            name="no_penalty_reserved_no"
            className="form-control form-control-190"
            id="no_penalty_reserved_no"
            disabled={true}
        />
        }
        else {
            return <React.Fragment>
                <div className="rrs-formgroup">

                <input
                                    key={`no_penalty_reserved_no${t_MR_DETAIL.transaction_no}`}
                                    name="no_penalty_reserved_no"
                                    defaultValue={t_MR_DETAIL.no_penalty_reserved_no}
                                    className="form-control form-control-190"
                                    id="no_penalty_reserved_no"
                                    onBlur={this.handleChange}
                                    //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false || viewMode}
                                    //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null  || t_MR_DETAIL.penalty_result === "penalty" || viewMode}
                                    //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false || viewMode}
                                    disabled={t_MR_DETAIL.delivery_exception_flag !== "delay_time"  || viewMode}
                                    ref={this.no_penalty_reserved_no_ref}
                                    maxLength="40"
                                />

                    {(t_MR_DETAIL.delivery_exception_flag !== "delay_time"  || viewMode) ? ('') : t_HEADER.product_type === "G" ?
                    (<IconButton color="primary" onClick={()=>{this.handleOnOpenReservedAdjustmentSelect()}} >
                        <i class="icon icon-preview-eye-blue"></i>
                    </IconButton>) : (<IconButton color="primary" onClick={()=>{this.handleOnOpenAdjustmentSelect()}} >
                        <i class="icon icon-preview-eye-blue"></i>
                    </IconButton>)}
                               
                </div>
            </React.Fragment>
        }
    }

    renderNoPenaltyNotifyNo() {
        let { t_MR_DETAIL,viewMode } = this.props;
       // || this.toBoolean(t_MR_DETAIL.no_penalty_flag)== false
        if (t_MR_DETAIL.delivery_exception_flag !== "delay_time" ){// || t_MR_DETAIL.penalty_result !== "no_penalty") {
            return <input
            name="no_penalty_notify_no"
            className="form-control form-control-190"
            id="no_penalty_notify_no"
            disabled={true}
            //ref={this.penalty_amount_ref}
        />
        }
        else {
            return <React.Fragment>
                <div className="rrs-formgroup">

                <input
                                    key={`no_penalty_notify_no${t_MR_DETAIL.transaction_no}`}
                                    name="no_penalty_notify_no"
                                    defaultValue={t_MR_DETAIL.no_penalty_notify_no}
                                    className="form-control form-control-190"
                                    id="no_penalty_notify_no"
                                    onBlur={this.handleChange}
                                    //disabled={t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false || viewMode}
                                    //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false  || viewMode}
                                    disabled={t_MR_DETAIL.delivery_exception_flag === "in_time"   || viewMode}    // || t_MR_DETAIL.penalty_result === "penalty" 
                                  
                                    maxLength="40"
                                    ref={this.no_penalty_notify_no_ref}
                                />

                    {(t_MR_DETAIL.delivery_exception_flag === "in_time" || viewMode) ? ('') : 
                    <IconButton color="primary" onClick={()=>{this.handleOnOpenAdjustmentSelect()}} >
                        <i class="icon icon-preview-eye-blue"></i>
                    </IconButton>}
                </div>
            </React.Fragment>
        }
    }

    renderPenaltyNotifyNo() {
        let { t_MR_DETAIL,viewMode } = this.props;
       // || this.toBoolean(t_MR_DETAIL.no_penalty_flag)== false
        if (t_MR_DETAIL.delivery_exception_flag !== "delay_time"){//  || t_MR_DETAIL.penalty_result !== "penalty") {
            return <input
            name="penalty_notify_no"
            className="form-control form-control-190"
            id="penalty_notify_no"
            disabled={true}
            //ref={this.penalty_amount_ref}
        />
        }
        else {
            return <React.Fragment>
                <div className="rrs-formgroup">

                <input
                                    key={`penalty_notify_no${t_MR_DETAIL.transaction_no}`}
                                    name="penalty_notify_no"
                                    defaultValue={t_MR_DETAIL.penalty_notify_no}
                                    className="form-control form-control-190"
                                    id="penalty_notify_no"
                                    onBlur={this.handleChange}
                                    //disabled={t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false || viewMode}
                                    //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false  || viewMode}
                                    disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result === "no_penalty"   || viewMode}
                                    maxLength="40"
                                />
                                
                </div>
            </React.Fragment>
        }
    }

    renderApproveDocDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        // || this.toBoolean(t_MR_DETAIL.no_penalty_flag)== false
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "no_penalty") {
            return <React.Fragment>
                <label htmlFor="approval_of_penalty_exception_doc_date" className="rrs-label rrs-label-75">
                    {lableName}
                </label>
                <div className="rrs-formgroup">
                <DatePicker
                        value={''}
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="no_penalty_approve_date"
                        id="no_penalty_approve_date"
                        tagid="mr.no_penalty_approve_date"
                        disabled={true}
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <label 
                    id="#lbl-mr.no_penalty_approve_date"
                    htmlFor="no_penalty_approve_date" 
                    className="rrs-label rrs-label-75" >
                    <span className="required">*</span>
                    {lableName}
                </label>
                <div className="rrs-formgroup">

                    <DatePicker
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="no_penalty_approve_date"
                        id="no_penalty_approve_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.no_penalty_approve_date && t_MR_DETAIL.no_penalty_approve_date !== ""
                            ? moment(t_MR_DETAIL.no_penalty_approve_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.no_penalty_approve_date"
                        disabled={viewMode || t_MR_DETAIL.no_penalty_flag == null}
                        viewMode={viewMode || t_MR_DETAIL.no_penalty_flag == null}
                    />
                </div>
            </React.Fragment>
        }
    }

    renderReserveDocDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
       // if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result === "penalty" || this.toBoolean(t_MR_DETAIL.no_penalty_flag) == false) {|| this.toBoolean(t_MR_DETAIL.no_penalty_flag)== false
        if (t_MR_DETAIL.delivery_exception_flag !== "delay_time"){// || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined  || t_MR_DETAIL.penalty_result !== "no_penalty") {
                  return <React.Fragment>
                <label htmlFor="no_penalty_reserved_date" className="rrs-label rrs-label-75">
                    {lableName}
                </label>
                <div className="rrs-formgroup">
                <DatePicker
                        value={ ''}
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="no_penalty_reserved_date"
                        id="no_penalty_reserved_date"
                        tagid="mr.no_penalty_reserved_date"
                        disabled={true}
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <label 
                    id="#lbl-mr.no_penalty_reserved_date"
                    htmlFor="no_penalty_reserved_date" 
                    className="rrs-label rrs-label-75" >
                    {
                            (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") 
                            && (/*<span className="required">*</span>*/ '')
                    }
                    {lableName}
                </label>
                <div className="rrs-formgroup">

                    <DatePicker
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="no_penalty_reserved_date"
                        id="no_penalty_reserved_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.no_penalty_reserved_date && t_MR_DETAIL.no_penalty_reserved_date !==""
                            ? moment(t_MR_DETAIL.no_penalty_reserved_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.no_penalty_reserved_date"
                        //disabled={viewMode || t_MR_DETAIL.no_penalty_flag == null}
                        disabled={t_MR_DETAIL.delivery_exception_flag === "in_time"   || viewMode}  
                        viewMode={t_MR_DETAIL.delivery_exception_flag === "in_time"   || viewMode}  
                        ref={this.no_penalty_reserved_date_ref}
                    />
                </div>
            </React.Fragment>
        }
    }
    
    renderPenaltyNotifyDocDate() {
            let lableName = "ลงวันที่"
            let { t_MR_DETAIL,viewMode } = this.props;
            //if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result === "penalty" || this.toBoolean(t_MR_DETAIL.no_penalty_flag) == false) {|| this.toBoolean(t_MR_DETAIL.no_penalty_flag)== false
                if (t_MR_DETAIL.delivery_exception_flag !== "delay_time" || t_MR_DETAIL.delivery_exception_flag === "" || t_MR_DETAIL.penalty_result !== "penalty") { 
                // || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined  
                      return <React.Fragment>
                    <label htmlFor="penalty_notify_date" className="rrs-label rrs-label-75">
                        {lableName}
                    </label>
                    <div className="rrs-formgroup">
                    <DatePicker
                            value={t_MR_DETAIL.penalty_notify_date != null ? t_MR_DETAIL.penalty_notify_date : ''}
                            //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                            name="penalty_notify_date"
                            id="penalty_notify_date"
                            tagid="mr.penalty_notify_date"
                            disabled={true}
                        />
                    </div>
                </React.Fragment>
            }
            else {
                return <React.Fragment>
                    <label 
                        id="#lbl-mr.penalty_notify_date"
                        htmlFor="penalty_notify_date" 
                        className="rrs-label rrs-label-75" >
                        <span className="required">*</span>
                        {lableName}
                    </label>
                    <div className="rrs-formgroup">
    
                        <DatePicker
                            //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                            name="penalty_notify_date"
                            id="penalty_notify_date"
                            onChange={this.handleChange}
                            onBlur={this.handleChange}
                            value={t_MR_DETAIL.penalty_notify_date
                                ? moment(t_MR_DETAIL.penalty_notify_date).format('DD/MM/YYYY')
                                : ""}
                            autocomplete="off"
                            readOnly={true}
                            doctype="*"
                            tagid="mr.penalty_notify_date"
                            disabled={viewMode } //|| t_MR_DETAIL.no_penalty_flag == null}
                            viewMode={viewMode } // || t_MR_DETAIL.no_penalty_flag == null}
                        />
                    </div>
                </React.Fragment>
            }
        }
       

    renderNotifyDocDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        //if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result === "penalty" || this.toBoolean(t_MR_DETAIL.no_penalty_flag) == false) {|| this.toBoolean(t_MR_DETAIL.no_penalty_flag)== false
            if (t_MR_DETAIL.delivery_exception_flag !== "delay_time"){// || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined  || t_MR_DETAIL.penalty_result !== "no_penalty") {
                  return <React.Fragment>
                <label htmlFor="no_penalty_notify_date" className="rrs-label rrs-label-75">
                    {lableName}
                </label>
                <div className="rrs-formgroup">
                <DatePicker
                        value={t_MR_DETAIL.no_penalty_notify_date != null ? t_MR_DETAIL.no_penalty_notify_date : ''}
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="no_penalty_notify_date"
                        id="no_penalty_notify_date"
                        tagid="mr.no_penalty_notify_date"
                        disabled={true}
                       
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <label 
                    id="#lbl-mr.no_penalty_notify_date"
                    htmlFor="no_penalty_notify_date" 
                    className="rrs-label rrs-label-75" >
                    {/* <span className="required">*</span> */}
                    {lableName}
                </label>
                <div className="rrs-formgroup">

                    <DatePicker
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="no_penalty_notify_date"
                        id="no_penalty_notify_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.no_penalty_notify_date
                            ? moment(t_MR_DETAIL.no_penalty_notify_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.penalty_no_exception_date"
                        disabled={viewMode} // || t_MR_DETAIL.no_penalty_flag == null}
                        viewMode={viewMode } //|| t_MR_DETAIL.no_penalty_flag == null}
                        ref={this.no_penalty_notify_date_ref}
                    />
                </div>
            </React.Fragment>
        }
    }
   

    renderNotiExceptionDocDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined || t_MR_DETAIL.penalty_result === "penalty") {
            return <React.Fragment>
                <label htmlFor="approval_of_penalty_exception_doc_date" className="rrs-label rrs-label-75">
                    {lableName}
                </label>
                <div className="rrs-formgroup">
                <DatePicker
                        value={t_MR_DETAIL.approval_of_penalty_exception_doc_date != null ? t_MR_DETAIL.approval_of_penalty_exception_doc_date : ''}
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="approval_of_penalty_exception_doc_date"
                        id="approval_of_penalty_exception_doc_date"
                        tagid="mr.penalty_no_exception_date"
                        disabled={true}
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <label 
                    id="#lbl-mr.penalty_no_exception_date"
                    htmlFor="approval_of_penalty_exception_doc_date" 
                    className="rrs-label rrs-label-75" >
                    <span className="required">*</span>
                    {lableName}
                </label>
                <div className="rrs-formgroup">

                    <DatePicker
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="approval_of_penalty_exception_doc_date"
                        id="approval_of_penalty_exception_doc_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.approval_of_penalty_exception_doc_date
                            ? moment(t_MR_DETAIL.approval_of_penalty_exception_doc_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.penalty_no_exception_date"
                        disabled={viewMode || t_MR_DETAIL.delivery_exception_flag == null}
                        viewMode={viewMode || t_MR_DETAIL.delivery_exception_flag == null}
                    />
                </div>
            </React.Fragment>
        }
    }

    renderUpDeptDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
            return <React.Fragment>
                <label 
                    id="#lbl-mr.penalty_no_exception_date"
                    htmlFor="up_dept_date" 
                    className="rrs-label rrs-label-75" >
                    <span className="required">*</span>
                    {lableName}
                </label>
                <div className="rrs-formgroup">

                    <DatePicker
                        //key={`up_dept_date${t_MR_DETAIL.transaction_no}`}
                        name="up_dept_date"
                        id="up_dept_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.up_dept_date
                            ? moment(t_MR_DETAIL.up_dept_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.up_dept_date"
                        disabled={viewMode || t_MR_DETAIL.up_dept_flag == null || t_MR_DETAIL.up_dept_flag == false}
                        viewMode={viewMode || t_MR_DETAIL.up_dept_flag == null || t_MR_DETAIL.up_dept_flag == false}
                    />
                </div>
            </React.Fragment>
        // }
    }

    renderDownDeptDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        // if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result === "penalty") {
        //     return <React.Fragment>
        //         <label htmlFor="approval_of_penalty_exception_doc_date" className="rrs-label rrs-label-75">
        //             {lableName}
        //         </label>
        //         <div className="rrs-formgroup">
        //         <DatePicker
        //                 value={t_MR_DETAIL.approval_of_penalty_exception_doc_date != null ? t_MR_DETAIL.approval_of_penalty_exception_doc_date : ''}
        //                 //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
        //                 name="approval_of_penalty_exception_doc_date"
        //                 id="approval_of_penalty_exception_doc_date"
        //                 tagid="mr.penalty_no_exception_date"
        //                 disabled={true}
        //             />
        //         </div>
        //     </React.Fragment>
        // }
        // else {
            return <React.Fragment>
                <label 
                    id="#lbl-mr.penalty_no_exception_date"
                    htmlFor="down_dept_date" 
                    className="rrs-label rrs-label-75" >
                    <span className="required">*</span>
                    {lableName}
                </label>
                <div className="rrs-formgroup">

                    <DatePicker
                        //key={`down_dept_date${t_MR_DETAIL.transaction_no}`}
                        name="down_dept_date"
                        id="down_dept_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.down_dept_date
                            ? moment(t_MR_DETAIL.down_dept_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.down_dept_date"
                        disabled={viewMode || t_MR_DETAIL.down_dept_flag == null || t_MR_DETAIL.down_dept_flag==false} 
                        viewMode={viewMode || t_MR_DETAIL.down_dept_flag == null || t_MR_DETAIL.down_dept_flag==false}
                    />
                </div>
            </React.Fragment>
        // }
    }

    getTransNo(){
        let result;

        let {temp_trans_att_no,t_MR_DETAIL} = this.props;
        let transaction_no = t_MR_DETAIL ? t_MR_DETAIL.transaction_no : ""
        result= transaction_no;
        if(transaction_no == "" || transaction_no == null || transaction_no == undefined)
            result=temp_trans_att_no;

        return result;
    }
    render() {

        const numeral = require('numeral');
        let { t_HEADER,t_MR_DETAIL,currency,viewMode, po_contract_no } = this.props;
        //("PanelFineMOM ==> " + t_MR_DETAIL.delay_day_no)
        return (
            <div className="sp-page-wrapper">
                <div className="rrs-detail-data">

                    <div className="row mt-0 mb-2 pt-3">
                        <div className="col-lg-12">
                            <div className="sp-header-button-panel2 justify-content-end">
                            <UploadButton
                                    transaction_no={this.getTransNo()}
                                    modalId={'attachedDocumentPenaltyModal'}
                                    viewMode={viewMode}
                                    defaultFileName ={'เอกสารแนบ'}
                                    file_category={'P'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="sp-table-container">
                        <div className="row no-gutters sp-table-content">

                             <UploadList
                                key={"uploadlist-panelfine-" + utilityHelper.genDateKey()}
                                transaction_no={t_MR_DETAIL.transaction_no}
                                file_category={'P'}
                                viewMode={viewMode}
                            /> 

                        </div>
                    </div>

                    <div className="row rrs-fine-box">
                        <div className="col-2">
                            <label className={`radiocontainer ${viewMode?'':'clickable'}`}>ภายในเวลากำหนด
                                <input
                                    type="radio"
                                    name={"delivery_exception_flag" + this.props.id}
                                    id={"delivery_exception_flag" + this.props.id}
                                    defaultValue="in_time"
                                    checked={t_MR_DETAIL.delivery_exception_flag === "in_time"}
                                    onChange={this.handleInTimeChange} 
                                    disabled={viewMode}
                                />
                                <span className="checkmark" />
                            </label>
                        </div>
                    </div>
                    <div className="row rrs-fine-box"> 
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 rrs-fine-box-bb">                      
                            <div className="col-2">
                                <label className={`radiocontainer rrs-fine-label ${viewMode?'':'clickable'}`}>
                                    {
                                        t_MR_DETAIL.delivery_exception_flag == "delay_time" 
                                        && (<span className="required">*</span>)
                                    }ล่าช้ากว่าเวลากำหนด
                                    <Information width={670}>
                                        <p style={{marginBottom:0}}><strong>1.กรณีมีค่าปรับ และ<span style={{"text-decoration":"underline"}}>ไม่มี</span>การ ลด/งด/ยกเว้นค่าปรับ</strong></p>
                                        <p style={{marginBottom:0}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull; เลือกกรอกข้อมูล &ldquo;คิดค่าปรับอัตราวันละ&rdquo; และค่าปรับอื่นๆ (ถ้ามี)</p>
                                        <p style={{marginBottom:0}}><strong>2.กรณีมีค่าปรับ แต่<span style={{"text-decoration":"underline"}}>มี</span>การงด/ยกเว้นค่าปรับ<span style={{"text-decoration":"underline"}}>ทั้งหมด</span></strong></p>
                                        <p style={{marginBottom:0}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull; เลือกกรอกข้อมูล &ldquo;ลด/งด/ยกเว้นค่าปรับ&rdquo;</p>
                                        <p style={{marginBottom:0}}><strong>3.กรณีมีค่าปรับ แต่<span style={{"text-decoration":"underline"}}>มี</span>การลด/ยกเว้นค่าปรับ<span style={{"text-decoration":"underline"}}>บางส่วน</span></strong></p>
                                        <p style={{marginBottom:0}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull; เลือกกรอกข้อมูล &ldquo;ค่าปรับอื่นๆ&rdquo; โดยให้ระบุจำนวนค่าปรับสุทธิที่หักจำนวนที่ลด/ยกเว้นค่าปรับ</p>
                                        <p style={{marginBottom:0}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; บางส่วนออกแล้ว รวมทั้งค่าปรับอื่นๆ (ถ้ามี) ทั้งนี้ โปรดระบุวิธีคำนวณ ในช่อง &ldquo;เนื่องจาก&rdquo;</p>
                                        <p style={{marginBottom:0}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull; เลือกกรอกข้อมูล &ldquo;ลด/งด/ยกเว้นค่าปรับ&rdquo;</p>
                                    </Information>
                                    <input
                                        type="radio"
                                        name={"delivery_exception_flag" + this.props.id}
                                        id={"delivery_exception_flag" + this.props.id}
                                        defaultValue="delay_time"
                                        checked={t_MR_DETAIL.delivery_exception_flag == "delay_time"}
                                        onChange={this.handleInTimeChange} 
                                        disabled={viewMode}
                                    />
                                    <span className="checkmark" />
                                </label>
                            </div>
                            <div className="col-2 rrs-detail-data d-flex">
                                {(t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null || viewMode === true)
                                    && (
                                        <input
                                            name="delay_day_no"
                                            className="form-control form-control-small"
                                            value ={viewMode ? numeral(t_MR_DETAIL.delay_day_no).format('0,0') : 0}
                                            id="delay_day_no"
                                            disabled={true}
                                        />
                                    )
                                }

                                {(t_MR_DETAIL.delivery_exception_flag == "delay_time" && viewMode !== true)
                                    && (
                                        <InputDecimal
                                            key={`delay_day_no${t_MR_DETAIL.transaction_no}`}
                                            name="delay_day_no"
                                            className="form-control form-control-small"
                                            id="delay_day_no"
                                            onBlur={this.handleChange}
                                            //onChange={this.handleChange}
                                            disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || viewMode}
                                            defaultValue={numeral(t_MR_DETAIL.delay_day_no).format('0,0')}
                                            //value={numeral(t_MR_DETAIL.delay_day_no).format('0,0')}
                                            inputMode="decimal"
                                            step="0,0"
                                            floatingPoint={0}
                                            maxLength="6"
                                            ref={this.delay_day_no}
                                        />
                                    )
                                }

                                
                                <label htmlFor="cc" className="rrs-label rrs-label-95 ml-2 ">วัน</label>
                            </div>
                            <div className="col-8 rrs-detail-data d-flex">
                                    <label htmlFor="cc" className="rrs-label rrs-label-95">
                                    {
                                        t_MR_DETAIL.delivery_exception_flag == "delay_time" 
                                        && (<span className="required">*</span>)
                                    }เนื่องจาก</label>
                                    <div className="col-xl-10 rrs-detail-data">
                                        <textarea
                                            cols={80}
                                            key={`delay_remark${t_MR_DETAIL.transaction_no}`}
                                            name="delay_remark"
                                            id="delay_remark"
                                            className="form-control"
                                            value={t_MR_DETAIL.delay_remark != null ? t_MR_DETAIL.delay_remark:''}
                                            onChange={this.handleChange} 
                                            disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || viewMode}
                                            ref={this.delay_remark_ref}
                                            maxLength="3000"
                                            />
                                    </div>
                                </div>
                        </div>
                    </div>
         
                    <div className="row rrs-fine-box">
                    <div className="col-12 d-md-flex align-items-start flex-wrap px-0"> 
                            <div className="col-1"></div>

                            {/* <div className="col-2 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`} id="#lbl-mr.penalty_flag">
                                    คิดค่าปรับในอัตราวันละ
                                    <input
                                        type="checkbox"
                                        name="penalty_flag"
                                        defaultValue="penalty_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.penalty_flag)}
                                        onChange={this.handlePenaltyChange}
                                        disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null || viewMode}
                                        ref={this.penalty_flag_ref}
                                    />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                             */}

                            <div className="col-2">
                                <label className={`radiocontainer rrs-fine-label ${viewMode?'':'clickable'}`} id="#lbl-mr.penalty_amount">
                                    {
                                        (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") == false
                                        && (<span className="required">*</span>)
                                    }
                                    คิดค่าปรับในอัตราวันละ
                                    <input
                                        type="radio"
                                        name={"penalty_result"+ this.props.id}
                                        id = {"penalty_result"+ + this.props.id}
                                        defaultValue="penalty"
                                        checked={t_MR_DETAIL.penalty_result === "penalty"}
                                        onChange={this.handlePenaltyChange}
                                        disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null || viewMode}
                                        ref={this.penalty_result_ref}
                                    />
                                    <span className="checkmark" />
                                </label>
                            </div>

                            <div className="col-2.5 rrs-detail-data d-flex">
                                {
                                    this.renderPenaltyAmount()
                                }
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-75">สกุลเงิน</label>
                                <input
                                    key={`pa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="pa_currency"
                                    onBlur={this.handleChange}
                                    disabled={true}

                                />
                            </div>
                  
                            <div className="col-auto">
                                <label className={`radiocontainer rrs-fine-label`} id="#lbl-mr.penalty_amount_net">
                                    คิดเป็นเงินค่าปรับ
                                </label>
                            </div>
                            <div className="col-auto rrs-detail-data d-flex">
                                {
                                    this.renderPenaltyAmountNet()
                                }
                            </div>
                            <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-75">สกุลเงิน</label>
                                <input
                                    key={`pa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="pa_currency"
                                    onBlur={this.handleChange}
                                    disabled={true}

                                />
                            </div>
                     </div>
                    </div>

                {false && (
                    <div className="row rrs-fine-box">
                            <div className="col-1"></div>
                            <div className="col-3 pl-5">

                                <label htmlFor="no_penalty_notify_no" className="rrs-label mr-3">                                
                                {
                                        (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") == false
                                        && (<span className="required">*</span>)
                                }แจ้งสงวนสิทธิ์การปรับแล้วตามหนังสือเลขที่</label>
                            </div>  
                            <div className="col-2 rrs-detail-data d-flex">  
                              {this.renderPenaltyDocNo()} 
                            
                            </div>
                            <div className="col-auto rrs-detail-data d-flex align-items-start">
                                {
                                      this.renderPenaltyDocDate()
                                }  
                            </div>

                    </div>                     
                )}
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 ">
                            <div className="col-1">
                                
                            </div>
                            <div className="col-2 col-rrs-checkbox">
                                    <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>ค่าปรับอื่นๆ เป็นจำนวนเงิน
                                        <input
                                            type="checkbox"
                                            name="other_penalty_flag"
                                            id="other_penalty_flag"
                                            checked={this.toBoolean(t_MR_DETAIL.other_penalty_flag)}
                                            onChange={this.handleOtherPenaltyChange} 
                                            disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined || viewMode}
                                            ref={this.other_penalty_flag_ref}
                                        />
                                        <span className="checkboxmark" />
                                    </label>
                            </div>
                            <div className="col-2.5 rrs-detail-data d-flex">
                                {/* {( this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false) //t_MR_DETAIL.delivery_exception_flag === "in_time" ||
                                    && (
                                        <input
                                            name="other_penalty_amount"
                                            className="form-control form-control-190 mr-3"
                                            id="other_penalty_amount"
                                            disabled={true}
                                        />
                                    )
                                }

                                {this.toBoolean(t_MR_DETAIL.other_penalty_flag) === true
                                    && (
                                        <InputDecimal
                                            name="other_penalty_amount"
                                            className="form-control form-control-190 mr-3"
                                            id="other_penalty_amount"
                                            onBlur={this.handleChange}
                                            disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false || viewMode}
                                            defaultValue={numeral(t_MR_DETAIL.delay_day_no).format('0,0')}
                                            inputMode="decimal"
                                            step="0,0"
                                            floatingPoint={0}
                                            maxLength="6"
                                        />
                                    )
                                } */}
                                {this.renderOtherPenaltyAmount()}

                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex flex-wrap">
                                    <label htmlFor="ddd" className="rrs-label rrs-label-75">สกุลเงิน</label>
                                    <input
                                        key={`pa_currency${t_MR_DETAIL.transaction_no}`}
                                        name="currency"
                                        defaultValue={currency}
                                        className="form-control form-control-small"
                                        id="pa_currency"
                                        onBlur={this.handleChange}
                                        disabled={true}

                                    />
                                    </div>
                            <div className="col-3 col-xl-5 rrs-detail-data d-flex">
                        <label htmlFor="other_penalty_remark" className="rrs-label rrs-label-95">
                        {
                           (t_MR_DETAIL.delivery_exception_flag === "in_time" || this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false) == false
                           && (<span className="required">*</span>)
                        } เนื่องจาก</label>
                        <textarea
                            key={`other_penalty_remark${t_MR_DETAIL.transaction_no}`}
                            name="other_penalty_remark"
                            value={t_MR_DETAIL.other_penalty_remark}
                            className="form-control"
                            id="other_penalty_remark"
                            onChange={this.handleChange}
                            disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false || viewMode}
                            ref={this.other_penalty_remark_ref}
                            maxLength="500"
                        />
                    </div>
                        </div>
                    </div>                          
                    
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 ">
                            <div className="col-1"></div>
{/* 
                            <div className="col-3 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>ลด / งด ยกเว้นค่าปรับ ตามหนังสืออนุมัติ เลขที่
                                <input
                                        type="checkbox"
                                        name="no_penalty_flag"
                                        defaultValue="no_penalty_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.no_penalty_flag)}
                                        onChange={this.handleNoPenaltyChange} 
                                        disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || t_MR_DETAIL.delivery_exception_flag === undefined  || viewMode}
                                        //ref={this.penalty_no_result_ref}
                                        ref={this.no_penalty_flag_ref}
                                        />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                             */}

                            <div className="col-3">
                                <label className={`radiocontainer rrs-fine-label ${viewMode?'':'clickable'}`}>ลด / งด / ยกเว้นค่าปรับ ตามหนังสืออนุมัติ เลขที่
                                <input
                                        type="radio"
                                        name={"penalty_result"  + this.props.id} 
                                        id  ={"penalty_result"  + this.props.id}
                                        defaultValue="no_penalty"
                                        checked={t_MR_DETAIL.penalty_result === "no_penalty"}
                                        onChange={this.handlePenaltyChange} 
                                        disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null || viewMode}
                                        ref={this.penalty_no_result_ref}
                                        />
                                    <span className="checkmark" />
                                </label>
                            </div>
                            

                            <div className="col-3 rrs-detail-data d-flex">

                                {/* <input
                                    key={`no_penalty_approve_no${t_MR_DETAIL.transaction_no}`}
                                    name="no_penalty_approve_no"
                                    defaultValue={t_MR_DETAIL.no_penalty_approve_no}
                                    className="form-control form-control-190"
                                    id="no_penalty_approve_no"
                                    onBlur={this.handleChange}
                                    //disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || t_MR_DETAIL.penalty_result === "penalty" || viewMode}
                                    disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false || viewMode}
                                   ref={this.no_penalty_approve_no_ref}
                                    maxLength="40"
                                   
                                /> */}
                                {
                                    this.renderNoPenaltyApproveNo()
                                }
                            </div>
                            <div className="col-auto rrs-detail-data d-flex align-items-start">
                                {
                                    this.renderApproveDocDate()
                                }
                                
                            </div>
                        </div>
                    </div>
                    {( t_HEADER.product_type === "G" && 
                    <div className="row rrs-fine-box">
                            <div className="col-1"></div>
                            <div className="col-3 pl-5">

                                <label htmlFor="no_penalty_notify_no" className="rrs-label mr-3">                                
                                {
                                        t_MR_DETAIL.delivery_exception_flag === "delay_time" //|| t_MR_DETAIL.penalty_result !== "penalty"
                                        && ('' /*<span className="required">*</span>*/)
                                }ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ เลขที่
                                                                <Information width={600}>
                                <p style={{marginBottom:0}}>*ข้อสังเกต แม้ว่าการตรวจรับครั้งนี้จะมีการงดค่าปรับทั้งหมดหรือลดค่าปรับเพียงบางส่วนให้แก่คู่สัญญา ปตท. ก็ควรยังต้องมีการจัดทำหนังสือแจ้งสิทธิ์การเรียกค่าปรับไปยังคู่สัญญาเสมอ เพื่อที่ว่าหากเกิดข้อพิพาทเรื่องค่าปรับเกิดขึ้น ปตท. ก็จะสามารถเรียกหรือหักค่าปรับจากคู่สัญญาได้ เนื่องจากได้แจ้งสิทธิ์ไว้แล้วตามที่กฎหมายกำหนด</p>        
                                    </Information>
                                </label>

                            </div>  
                            <div className="col-3 rrs-detail-data d-flex">  
                             {/*    <input
                                    key={`no_penalty_notify_no${t_MR_DETAIL.transaction_no}`}
                                    name="no_penalty_notify_no"
                                    defaultValue={t_MR_DETAIL.no_penalty_notify_no}
                                    className="form-control form-control-190"
                                    id="no_penalty_notify_no"
                                    onBlur={this.handleChange}
                                    //disabled={t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false || viewMode}
                                    disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false  || viewMode}

                                    maxLength="40"
                                /> */}
                              {this.renderNoPenaltyNotifyNo()} 
                            
                            </div>
                            <div className="col-auto rrs-detail-data d-flex align-items-start">
                                {
                                      this.renderNotifyDocDate()
                                }
                                
                            </div>

                    </div>
                    )}
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 rrs-fine-box-bb">
                            <div className="col-1"></div>
                            <div className="col-3 pl-5">

                                <label htmlFor="no_penalty_reserved_no" className="rrs-label mr-3">                                
                                {
                                        ((t_MR_DETAIL.delivery_exception_flag == "delay_time" && t_MR_DETAIL.penalty_result !== "penalty") || t_HEADER.product_type ==="C" )
                                        && (/*<span className="required">*</span>*/ '')
                                } {t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ เลขที่":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ เลขที่"}
                                                                {t_HEADER.product_type==="G" && (
                                    <Information width={600}>
                                    <p style={{marginBottom:0}}>*ข้อสังเกต แม้ว่าการตรวจรับครั้งนี้จะมีการงดค่าปรับทั้งหมดหรือลดค่าปรับเพียงบางส่วนให้แก่คู่สัญญา ปตท. ก็ควรยังต้องมีการจัดทำหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับไปยังคู่สัญญาเสมอ เพื่อที่ว่าหากเกิดข้อพิพาทเรื่องค่าปรับเกิดขึ้น ปตท. ก็จะสามารถเรียกหรือหักค่าปรับจากคู่สัญญาได้ เนื่องจากได้แจ้งสงวนสิทธิ์ไว้แล้วตามที่กฎหมายกำหนด</p>
                                </Information>
                                )}
                                {t_HEADER.product_type==="C" && (
                                    <Information width={600}>
                                    <p style={{marginBottom:0}}>*ข้อสังเกต แม้ว่าการตรวจรับครั้งนี้จะมีการงดค่าปรับทั้งหมดหรือลดค่าปรับเพียงบางส่วนให้แก่คู่สัญญา ปตท. ก็ควรยังต้องมีการจัดทำหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับไปยังคู่สัญญาเสมอ เพื่อที่ว่าหากเกิดข้อพิพาทเรื่องค่าปรับเกิดขึ้น ปตท. ก็จะสามารถเรียกหรือหักค่าปรับจากคู่สัญญาได้ เนื่องจากได้แจ้งสงวนสิทธิ์ไว้แล้วตามที่กฎหมายกำหนด</p>
                                </Information>
                                )}
                                </label>

                            </div>
                            <div className="col-3 rrs-detail-data d-flex">
                                {/* <input
                                    key={`no_penalty_reserved_no${t_MR_DETAIL.transaction_no}`}
                                    name="no_penalty_reserved_no"
                                    defaultValue={t_MR_DETAIL.no_penalty_reserved_no}
                                    className="form-control form-control-190"
                                    id="no_penalty_reserved_no"
                                    onBlur={this.handleChange}
                                    disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.no_penalty_flag == null  || this.toBoolean(t_MR_DETAIL.no_penalty_flag) === false || viewMode}
                                    maxLength="40"
                                /> */}
                                {this.renderNoPenaltyReserveNo()}
                            </div>
                            <div className="col-auto rrs-detail-data d-flex align-items-start">
                                {
                                      this.renderReserveDocDate()
                                }
                                
                            </div>
                        </div>
                    </div>

                    {/* zone checkbox */}
                    {/* <div className="row rrs-fine-box">
                        <div className="col-1">
                            
                        </div>
                        <div className="col-2 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>ค่าปรับอื่นๆ เป็นจำนวนเงิน
                                    <input
                                        type="checkbox"
                                        name="other_penalty_flag"
                                        id="other_penalty_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.other_penalty_flag)}
                                        onChange={this.handleOtherPenaltyChange} 
                                        disabled={viewMode}
                                    />
                                    <span className="checkboxmark" />
                                </label>
                        </div>
                        <div className="col-2.5 rrs-detail-data d-flex">
                            {( this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false) //t_MR_DETAIL.delivery_exception_flag === "in_time" ||
                                && (
                                    <input
                                        name="other_penalty_amount"
                                        className="form-control form-control-190 mr-3"
                                        id="other_penalty_amount"
                                        disabled={true}
                                    />
                                )
                            }

                            {this.toBoolean(t_MR_DETAIL.other_penalty_flag) === true
                                && (
                                    <InputDecimal
                                        name="other_penalty_amount"
                                        className="form-control form-control-190 mr-3"
                                        id="other_penalty_amount"
                                        onBlur={this.handleChange}
                                        disabled={this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false || viewMode}
                                        defaultValue={numeral(t_MR_DETAIL.delay_day_no).format('0,0')}
                                        inputMode="decimal"
                                        step="0,0"
                                        floatingPoint={0}
                                        maxLength="6"
                                    />
                                )
                            }

                        </div>
                        <div className="col-1.5 rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-75">สกุลเงิน</label>
                                <input
                                    key={`pa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="pa_currency"
                                    onBlur={this.handleChange}
                                    disabled={true}

                                />
                                </div>
                        <div className="col-3 col-xl-5 rrs-detail-data d-flex">
                        <label htmlFor="other_penalty_remark" className="rrs-label rrs-label-95">เนื่องจาก</label>
                        <textarea
                            key={`other_penalty_remark${t_MR_DETAIL.transaction_no}`}
                            name="other_penalty_remark"
                            value={t_MR_DETAIL.other_penalty_remark}
                            className="form-control"
                            id="other_penalty_remark"
                            onChange={this.handleChange}
                            disabled={this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false || viewMode}
                            ref={this.other_penalty_remark_ref}
                            maxLength="500"
                        />
                    </div>

                    </div>                          
                     */}
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 ">
                            <div className="col-1"></div>
                            <div className="col-2 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>
                                {
                                        t_MR_DETAIL.retention_flag && t_MR_DETAIL.retention_flag === true
                                        && (<span className="required">*</span>)
                                    }
                                    Retention เป็นจำนวนเงิน
                                    <input
                                        type="checkbox"
                                        name="retention_flag"
                                        id="retention_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.retention_flag)}
                                        onChange={this.handleRetentionChange} 
                                        disabled={viewMode}
                                    />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            <div className="col-2.5 rrs-detail-data d-flex">
                                { (this.toBoolean(t_MR_DETAIL.retention_flag) === false || viewMode=== true)
                                    && (
                                    <input
                                        name="retention_amount"
                                        className="form-control form-control-190 mr-3"
                                        id="retention_amount"
                                        value={viewMode?numeral(t_MR_DETAIL.retention_amount).format('0,0.00'): numeral(0).format('0,0.00')}
                                        inputMode="decimal"
                                        step="0,0.00"
                                        disabled={true}
                                    />
                                    )
                                }
                                {
                                    (this.toBoolean(t_MR_DETAIL.retention_flag) === true && viewMode === false)
                                    && (
                                        <InputDecimal
                                    name="retention_amount"
                                    // pattern="[0-9.]*"
                                    // defaultValue={t_MR_DETAIL.retention_amount}
                                    className="form-control form-control-190 mr-3"
                                    id="retention_amount"
                                    onBlur={this.handleChange}
                                    //onChange={this.handleChange}
                                    disabled={this.toBoolean(t_MR_DETAIL.retention_flag) === false || viewMode}
                                    //ref={this.retention_amount_ref}
                                    defaultValue={numeral(this.chkNumber(t_MR_DETAIL.retention_amount)).format('0,0.00')}
                                    inputMode="decimal"
                                    step="0,0.00"
                                    
                                />
                                    )
                                }
                                
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex">
                                <label htmlFor="ddd" className="rrs-label rrs-label-75">สกุลเงิน</label>
                                <input
                                    key={`opa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="opa_currency"
                                    disabled={true}
                                />
                            </div>
                            <div className="col-3 col-xl-5 rrs-detail-data d-flex">
                                <label htmlFor="retention_remark" className="rrs-label rrs-label-95">เนื่องจาก</label>
                                <textarea
                                    key={`retention_remark${t_MR_DETAIL.transaction_no}`}
                                    name="retention_remark"
                                    value={t_MR_DETAIL.retention_remark}
                                    className="form-control"
                                    id="retention_remark"
                                    onChange={this.handleChange}
                                    disabled={this.toBoolean(t_MR_DETAIL.retention_flag) === false || viewMode}
                                    ref={this.retention_remark_ref}
                                    maxLength="500"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 "> 
                            <div className="col-1"></div>
                            <div className="col-2 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>
                                {
                                        t_MR_DETAIL.advance_payment_flag && t_MR_DETAIL.advance_payment_flag === true
                                        && (<span className="required">*</span>)
                                    }
                                    Advance Payment เป็นจำนวนเงิน
                                    <input
                                        type="checkbox"
                                        name="advance_payment_flag"
                                        id="advance_payment_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.advance_payment_flag)}
                                        onChange={this.handleAdvancePaymentChange} 
                                        disabled={viewMode}    
                                    />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            <div className="col-2.5 rrs-detail-data d-flex">
                                { (this.toBoolean(t_MR_DETAIL.advance_payment_flag) === false || viewMode === true)
                                    && (
                                    <input
                                        name="advance_payment_amount"
                                        className="form-control form-control-190 mr-3"
                                        id="advance_payment_amount"
                                        value={viewMode?numeral(t_MR_DETAIL.advance_payment_amount).format('0,0.00') : numeral(0).format('0,0.00')}
                                        disabled={true}
                                        inputMode="decimal"
                                        step="0,0.00"
                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.advance_payment_flag) === true && viewMode === false
                                    && (
                                        <InputDecimal
                                        name="advance_payment_amount"
                                        // pattern="[0-9.]*"
                                        // defaultValue={t_MR_DETAIL.advance_payment_amount}
                                        className="form-control form-control-190 mr-3"
                                        id="advance_payment_amount"
                                        onBlur={this.handleChange}
                                        //onChange={this.handleChange}
                                        disabled={this.toBoolean(t_MR_DETAIL.advance_payment_flag) === false || viewMode}
                                        //ref={this.advance_payment_amount_ref}
                                        defaultValue={numeral(t_MR_DETAIL.advance_payment_amount).format('0,0.00')}
                                        inputMode="decimal"
                                        step="0,0.00"
    
                                    />
                                    )
                                }
                                
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-75">สกุลเงิน</label>
                                <input
                                    key={`ra_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="ra_currency"
                                    disabled={true}
                                />
                            </div>
                            <div className="col-3 col-xl-5 rrs-detail-data d-flex">
                                <label htmlFor="advance_payment_remark" className="rrs-label rrs-label-95">เนื่องจาก</label>
                                <textarea
                                    key={`advance_payment_remark${t_MR_DETAIL.transaction_no}`}
                                    name="advance_payment_remark"
                                    value={t_MR_DETAIL.advance_payment_remark}
                                    className="form-control"
                                    id="advance_payment_remark"
                                    onChange={this.handleChange}
                                    disabled={this.toBoolean(t_MR_DETAIL.advance_payment_flag) === false || viewMode }
                                    ref={this.advance_payment_remark_ref}
                                    maxLength="500"

                                />
                            </div>
                        </div>
                    </div>
                    
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 ">
                            <div className="col-1"></div>
                            <div className="col-1 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>
                                {
                                        t_MR_DETAIL.down_dept_flag && t_MR_DETAIL.down_dept_flag === true
                                        && (<span className="required">*</span>)
                                    }ใบลดหนี้
                                    <input
                                        type="checkbox"
                                        name="down_dept_flag"
                                        id="down_dept_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.down_dept_flag)}                                  
                                        onChange={this.handleDownDeptChange} 
                                        disabled={viewMode}        
                                    />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex">
                                { (this.toBoolean(t_MR_DETAIL.down_dept_flag) === false || viewMode=== true)
                                    && (
                                    <input
                                        name="down_dept_amount"
                                        className="form-control form-control-150 mr-3"
                                        id="down_dept_amount"
                                        disabled={true}
                                        value={viewMode?numeral(t_MR_DETAIL.down_dept_amount).format('0,0.00'): numeral(0).format('0,0.00')}
                                        inputMode="decimal"
                                        step="0,0.00"
                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.down_dept_flag) === true && viewMode === false
                                    && (
                                        <InputDecimal
                                        name="down_dept_amount"
                                        // pattern="[0-9.]*"
                                        // defaultValue={t_MR_DETAIL.advance_payment_amount}
                                        className="form-control form-control-150 mr-3"
                                        id={"down_dept_amount"+ this.props.id}
                                        onBlur={this.handleChange} 
                                        //onChange={this.handleChange} 
                                        disabled={this.toBoolean(t_MR_DETAIL.down_dept_flag) === false || viewMode}
                                        //ref={this.advance_payment_amount_ref}
                                        defaultValue={numeral(t_MR_DETAIL.down_dept_amount).format('0,0.00')}
                                        inputMode="decimal"
                                        step="0,0.00"
    
                                        />
                                    )
                                }
                                
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-75">สกุลเงิน</label>
                                <input
                                    key={`apa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="apa_currency"
                                    onBlur={this.handleChange}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-1 rrs-detail-data d-flex">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>งวดที่
                                </label>
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex">
                                { this.toBoolean(t_MR_DETAIL.down_dept_flag) === false
                                    && (
                                    <input
                                        name="down_dept_period"
                                        className="form-control form-control-150 mr-3"
                                        id="down_dept_period"
                                        disabled={true}
                                        //inputMode="decimal"
                                        step="0,0.00"
                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.down_dept_flag) === true
                                    && (
                                        <input
                                        name="down_dept_period"
                                        // pattern="[0-9.]*"
                                        // defaultValue={t_MR_DETAIL.advance_payment_amount}
                                        className="form-control form-control-150 mr-3"
                                        id="down_dept_period"
                                        onBlur={this.handleChange} 
                                        onChange={this.handleChange} 
                                        disabled={this.toBoolean(t_MR_DETAIL.down_dept_flag) === false || viewMode}
                                        //ref={this.advance_payment_amount_ref}
                                        //defaultValue={t_MR_DETAIL.down_dept_period}
                                        value={t_MR_DETAIL.down_dept_period}
                                        //inputMode="decimal"
                                        step="0,0.00"
    
                                        />
                                    )
                                }
                                
                            </div>
                            <div className="col-1 rrs-detail-data d-flex">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>เลขที่
                                </label>
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex">
                                { this.toBoolean(t_MR_DETAIL.down_dept_flag) === false
                                    && (
                                    <input
                                        name="down_dept_no"
                                        className="form-control form-control-150 mr-3"
                                        id="down_dept_no"
                                        disabled={true}
                                        //inputMode="decimal"
                                        //step="0,0.00"
                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.down_dept_flag) === true
                                    && (
                                        <input
                                        name="down_dept_no"
                                        // pattern="[0-9.]*"
                                        // defaultValue={t_MR_DETAIL.advance_payment_amount}
                                        className="form-control form-control-150 mr-3"
                                        id="down_dept_no"
                                        onBlur={this.handleChange} 
                                        onChange={this.handleChange} 
                                        disabled={this.toBoolean(t_MR_DETAIL.down_dept_flag) === false || viewMode}
                                        //ref={this.advance_payment_amount_ref}
                                        value={t_MR_DETAIL.down_dept_no}
                                        //inputMode="decimal"
                                        //step="0,0.00"
    
                                        />
                                    )
                                }
                                
                            </div>
                            <div className="col-auto rrs-detail-data d-flex align-items-start">
                                {
                                    this.renderDownDeptDate()
                                }
                                
                            </div>
                        </div>
                    </div>
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 rrs-fine-box-bb">

                            <div className="col-1"></div>
                            <div className="col-1 col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>
                                {
                                        t_MR_DETAIL.up_dept_flag && t_MR_DETAIL.up_dept_flag === true
                                        && (<span className="required">*</span>)
                                    }ใบเพิ่มหนี้
                                    <input
                                        type="checkbox"
                                        name="up_dept_flag"
                                        id="up_dept_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.up_dept_flag)}
                                        onChange={this.handleUpDeptChange} 
                                        disabled={viewMode}        
                                    />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex">
                                { (this.toBoolean(t_MR_DETAIL.up_dept_flag) === false || viewMode === true)
                                    && (
                                    <input
                                        name="up_dept_amount"
                                        className="form-control form-control-150 mr-3"
                                        id="up_dept_amount"
                                        disabled={true}
                                        value={viewMode?numeral(t_MR_DETAIL.up_dept_amount).format('0,0.00'): numeral(0).format('0,0.00')}
                                        inputMode="decimal"
                                        step="0,0.00"
                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.up_dept_flag) === true && viewMode === false
                                    && (
                                        <InputDecimal
                                        name="up_dept_amount"
                                        // pattern="[0-9.]*"
                                        // defaultValue={t_MR_DETAIL.advance_payment_amount}
                                        className="form-control form-control-150 mr-3"
                                        id="up_dept_amount"
                                        onBlur={this.handleChange} 
                                        //onChange={this.handleChange} 
                                        disabled={this.toBoolean(t_MR_DETAIL.up_dept_flag) === false || viewMode}
                                        //ref={this.advance_payment_amount_ref}
                                        defaultValue={numeral(t_MR_DETAIL.up_dept_amount).format('0,0.00')}
                                        inputMode="decimal"
                                        step="0,0.00"
    
                                        />
                                    )
                                }
                                
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-75">สกุลเงิน</label>
                                <input
                                    key={`apa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="apa_currency"
                                    onBlur={this.handleChange}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-1 rrs-detail-data d-flex">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>งวดที่
                                </label>
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex">
                                { this.toBoolean(t_MR_DETAIL.up_dept_flag) === false
                                    && (
                                    <input
                                        name="up_dept_period"
                                        className="form-control form-control-150 mr-3"
                                        id="up_dept_period"
                                        disabled={true}
                                        inputMode="decimal"
                                        step="0,0.00"
                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.up_dept_flag) === true
                                    && (
                                        <input
                                        name="up_dept_period"
                                        className="form-control form-control-150 mr-3"
                                        id="up_dept_period"
                                        onBlur={this.handleChange} 
                                        onChange={this.handleChange} 
                                        disabled={this.toBoolean(t_MR_DETAIL.up_dept_flag) === false || viewMode}
                                        value={t_MR_DETAIL.up_dept_period}

    
                                        />
                                    )
                                }
                                
                            </div>
                            <div className="col-1 rrs-detail-data d-flex">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>เลขที่
                                </label>
                            </div>
                            <div className="col-1.5 rrs-detail-data d-flex">
                                { this.toBoolean(t_MR_DETAIL.up_dept_flag) === false
                                    && (
                                    <input
                                        name="up_dept_no"
                                        className="form-control form-control-150 mr-3"
                                        id="up_dept_no"
                                        disabled={true}
                                        inputMode="decimal"

                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.up_dept_flag) === true
                                    && (
                                        <input
                                        name="up_dept_no"
                                        className="form-control form-control-150 mr-3"
                                        id="up_dept_no"
                                        onBlur={this.handleChange} 
                                        onChange={this.handleChange} 
                                        disabled={this.toBoolean(t_MR_DETAIL.up_dept_flag) === false || viewMode}
                                        value={t_MR_DETAIL.up_dept_no}
                                        />
                                    )
                                }
                                
                            </div>
                            <div className="col-auto rrs-detail-data d-flex align-items-start">
                                {
                                    this.renderUpDeptDate()
                                }
                                
                            </div>
                        </div>
                      </div>

                   {/* zone checkbox */}
                </div>
                <AdjustmentSelect data_type="adjust" open={this.state.openAdjustmentSelect} po_contract_no={po_contract_no} onClose={()=>{this.handleOnCloseAdjustmentSelect()}} onSelect={(obj)=>{this.handleOnSelectAdjustment(obj)}}></AdjustmentSelect>
                <AdjustmentSelect data_type="reserved-adjust" open={this.state.openReservedAdjustmentSelect} po_contract_no={po_contract_no} onClose={()=>{this.handleOnCloseReservedAdjustmentSelect()}} onSelect={(obj)=>{this.handleOnSelectReservedAdjustment(obj)}}></AdjustmentSelect>
            </div>

        )
    }
}

const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        temp_trans_att_no: MainRedux.temp_trans_att_no,
        t_IR_ITEM: MainRedux.t_IR_ITEM,
        t_MR_DETAIL :MainRedux.t_MR_DETAIL,
    }
}

export default connect(
    mapStateToProps,
    null
)(PanelFineMom)